import { useEffect } from "react";
import { useForm } from "react-hook-form";
import LabelInput from "../../../shared/components/labelInput";
import QuoteFormWrapper from "../../../shared/components/quoteFormWrapper";
import FormNavigationButtons from "../../../shared/components/FormNavigationButtons";
import BuyStep from "../enums/BuyStep";
import { handleNext } from "../../../shared/utils/navigationUtils";
import TbDirectDebitMapper from "../mappers/tbDirectDebitMapper";
import { downloadPreContractAgreement } from "../../../shared/utils/apiUtils";
import { useNavigate } from "fusion-plugin-react-router";
import useQuoteStore from "../../quote/store/QuoteStore";
import useAppStateStore from "../../../shared/store/AppStateStore";
import { HotjarEventNames } from "../../../shared/utils/hotjarEventNames";
import { TrackHotjarEvent } from "../../../shared/utils/trackHotjarEvent";

const TbDirectDebitDetails = ({ METHODS }) => {
  // Initialize model
  const navigate = useNavigate();
  const {
    register,
    formState: { errors, isValid },
    watch,
    setValue,
    trigger,
    handleSubmit,
  } = useForm({
    defaultValues: TbDirectDebitMapper.get(),
  });

  let STATE = useAppStateStore();

  const handleSortCodeChange = (e) => {
    let value = e.target.value.replace(/[^0-9]/g, "").slice(0, 6);
    const formattedValue = value.match(/.{1,2}/g)?.join("-") || "";
    e.target.value = formattedValue;
    setValue("sortCodeFormatted", value, { shouldValidate: true });
  };

  const handleAccountNumberChange = (e) => {
    let value = e.target.value.replace(/[^0-9]/g, "").slice(0, 8);
    setValue("AccountNo", value, { shouldValidate: true });
  };

  useEffect(() => {
    TrackHotjarEvent(HotjarEventNames.TAXI_QUOTE_TBDIRECTDEBITDETAILS_ENTERED);
  }, []);

  const onSubmit = (data) => {
    // Save form data to store
    TbDirectDebitMapper.set(data);
    TrackHotjarEvent(
      HotjarEventNames.TAXI_QUOTE_TBDIRECTDEBITDETAILS_NEXT_CLICKED
    );

    // Navigate to next page
    handleNext(BuyStep.TB_GLOBAL_PAYMENTS_PAGE, STATE);
  };

  const riskObjectId = useQuoteStore.getState().quote?.risk.riskObjectId;
  const riskObjectHistoryId = useQuoteStore.getState().quote?.risk
    .riskObjectHistoryId;

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <QuoteFormWrapper>
        <h1 className="margin-bottom-10">Enter your payment details</h1>
        <p className="gray-text margin-bottom-10 margin-top-0">
          If you require a direct debit payment facility, all our applications
          are passed to Premium Credit Ltd. Credit is subject to status and they
          may use a credit reference agency that leaves a record of the search
          or other information about you to carry our credit and anti-money
          laundering checks. This check will be visible to third parties.
        </p>
        <p className="gray-text margin-bottom-20 margin-top-0">
          If you would like to see your Premium Credit Pre Contractual
          agreement, please{" "}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              downloadPreContractAgreement({
                navigate,
                riskObjectId,
                riskObjectHistoryId,
              });
            }}
          >
            click here
          </a>
          .
        </p>
        <p>
          Based on the information we have provided please ensure that the
          monthly repayments are affordable for you
        </p>

        <LabelInput
          id="sortCode"
          label="Sort code"
          type="text"
          placeholder="12-12-12"
          register={register("sortCode", {
            required: "Required",
            onChange: (e) => handleSortCodeChange(e),
          })}
          errors={errors.sortCode}
          watch={watch("sortCode")}
          trigger={trigger}
        />

        <LabelInput
          id="AccountNo"
          label="Account Number"
          type="text"
          placeholder="Enter account number"
          register={register("AccountNo", {
            required: "Required",
            maxLength: {
              value: 8,
              message: "Account number must not exceed 8 characters",
            },
            onChange: (e) => handleAccountNumberChange(e),
          })}
          errors={errors.AccountNo}
          watch={watch("AccountNo")}
          trigger={trigger}
        />

        <div className="termsContainer">
          <input
            type="checkbox"
            id="docTermsAccepted"
            {...register("docTermsAccepted", {
              required:
                "You cannot proceed to purchase without confirming that you are the registered account holder.",
            })}
          />
          <label htmlFor="docTermsAccepted" className="termsLabel">
            Please be advised, we are unable to accept payment from a bank
            account that is not registered in the policyholder's name. Please
            tick this box to confirm that you are the registered account holder.
          </label>
          {errors.docTermsAccepted && (
            <span className="errorField font-12">
              {errors.docTermsAccepted.message}
            </span>
          )}
        </div>
      </QuoteFormWrapper>

      <FormNavigationButtons
        STATE={STATE}
        METHODS={METHODS}
        prevStep={BuyStep.TB_E_PAYMENT}
        isValid={isValid}
      />
    </form>
  );
};

export default TbDirectDebitDetails;
